import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  CheckExpensesTable,
  CheckItemsTable,
  invoiceItemsTable,
  salesOrderItemsTable,
} from "../../../config/grid-column-defs";
import { getTransactionVendorExpenses } from "../../../api/transaction-type";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Tabs,
  Tab,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import TabPanel from "../../../components/TabPanel";

export default function CheckItems() {
  const [tabIndex, setTabIndex] = useState(0);
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const pageDetail = slugMap[params.slug];
  const [rowData, setRowData] = useState([]);
  const [ExpData, setItems] = useState([]);
  // async function getTransactionItemsData(limit,offset) {
  //   setLoading(true);
  //   try {
  //     const { data } = await getTransactionVendorItems(user.token, {
  //       id: params.docNo,
  //       limit,
  //       offset
  //     });
  //     setRowData(data.data);
  //     setLoading(false);
  //     return {
  //       rows: data.data.items,
  //       total: data.data.itemstotal,
  //       error: false,
  //     };
  //   } catch (error) {
  //     console.log(error);
  //     setLoading(false);
  //     snackbar.showError("Error In Loading Data.");
  //     return { error: true };
  //   } finally {
  //     setLoading(false);
  //   }
  // }
  async function getTransactionVendorExpensesData(limit,offset) {
    setLoading(true);
    try {
      const { data } = await getTransactionVendorExpenses(user.token, {
        id: params.docNo,
        limit,
        offset
      });
      setItems(data.data);
      setLoading(false);
      return {
        rows: data.data.data,
        total: data.data.dataCount,
        error: false,
      };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
console.log(rowData)
  return (
    <>
      <Box className="viewDetilsBox">
        <Tabs
          value={tabIndex}
          // onChange={handleChange}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className="tabs-sub-bkg"
        >
          <Tab label={`Expenses  ${ExpData?.expensetotal || "0.00"}`} />
          <Tab label={`Items ${rowData?.itemsum || "0.00"}`} />
        </Tabs>
        {/*----------Messages------------*/}
        <TabPanel value={tabIndex} index={0}>
          <AgGridPaginatedTable
            getTableRows={getTransactionVendorExpensesData}
            columns={CheckExpensesTable}
            refreshCounter={0}
          />
        </TabPanel>
        <TabPanel value={tabIndex} index={1}>
         {
          tabIndex ===1 && <AgGridPaginatedTable
          // getTableRows={getTransactionItemsData}
          columns={CheckItemsTable}
          refreshCounter={0}
        />
         }
        </TabPanel>
      </Box>
    </>
  );
}
